import React from "react";
import useAuth from "../../../hooks/useAuth";
import { UserType } from "../../../utils/enum";
import UserInformation from "../components/UserInformation";
import ParentCustomerInformation from "../components/ParentCustomerInformation";
import About from "../components/About";

const CustomerProfile = ({ user, refetchMe, hideCustomerInfo = false }) => {
  const { auth, authRole } = useAuth();
  const isSelfView = auth?.user?.id === user?.id;

  const canSeeUserInfo = isSelfView || authRole === UserType.CLIENT || authRole === UserType.ADMIN;

  const canSeeCustomerInfo =
    !hideCustomerInfo &&
    (isSelfView || authRole === UserType.CLIENT || authRole === UserType.ADMIN);

  return (
    <div className="grid grid-cols-1">
      <div>
        {canSeeCustomerInfo && (
          <ParentCustomerInformation
            customer={user?.customer}
            showServicedBy={!isSelfView}
            showAnnualRevenue={isSelfView || authRole === UserType.ADMIN}
            tag={authRole === UserType.CLIENT || authRole === UserType.ADMIN ? "Customer" : null}
          />
        )}

        {canSeeUserInfo && (
          <UserInformation
            refetchMe={refetchMe}
            canEdit={authRole === UserType.ADMIN}
            userInfo={{
              userId: user?.id,
              firstName: user?.firstName,
              lastName: user?.lastName,
              name: `${user?.firstName || ""} ${user?.lastName || ""}`.trim(),
              email: user?.email,
              phoneNumber: user?.phoneNumber,
              createdAt: user?.createdAt,
              lastActive: user?.lastActive,
            }}
          />
        )}

        <About description={user?.description} />
      </div>
    </div>
  );
};

export default CustomerProfile;
